import React from 'react';
import { DecoratorNode } from 'lexical';

// Custom Emote Node for Lexical
export class EmoteNode extends DecoratorNode {
  __emoteId;
  __emoteName;
  __emoteUrl;

  static getType() {
    return 'kick-emote';
  }

  static clone(node) {
    return new EmoteNode(node.__emoteId, node.__emoteName, node.__emoteUrl, node.__key);
  }

  static importJSON(serializedNode) {
    const node = $createEmoteNode(
      serializedNode.emoteId,
      serializedNode.emoteName,
      serializedNode.emoteUrl
    );
    return node;
  }

  constructor(emoteId, emoteName, emoteUrl, key) {
    super(key);
    this.__emoteId = emoteId;
    this.__emoteName = emoteName;
    this.__emoteUrl = emoteUrl;
  }

  createDOM() {
    const span = document.createElement('span');
    span.className = 'editor-emote-node';
    return span;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return (
      <img
        src={this.__emoteUrl}
        alt={this.__emoteName}
        className="inline-emote"
        draggable="false"
        style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          height: '1.5em',
          width: 'auto',
          margin: '0 2px',
        }}
      />
    );
  }

  exportJSON() {
    return {
      emoteId: this.__emoteId,
      emoteName: this.__emoteName,
      emoteUrl: this.__emoteUrl,
      type: 'kick-emote',
      version: 1,
    };
  }

  getTextContent() {
    return `[emote:${this.__emoteId}:${this.__emoteName}]`;
  }
}

export function $createEmoteNode(emoteId, emoteName, emoteUrl) {
  return new EmoteNode(emoteId, emoteName, emoteUrl);
}

export function $isEmoteNode(node) {
  return node instanceof EmoteNode;
}